<page-heading
  [title]="'contact.contact.pageTitle' | translate"
  [description]="'contact.contact.pageDescription' | translate"
/>
<div class="mb-3 position-relative">
  <ul class="nav nav-tabs nav-bordered" role="tablist">
    <li class="nav-item">
      <a
        class="nav-link active"
        id="contacts-tab"
        data-bs-toggle="tab"
        data-bs-target="#contacts"
        type="button"
        role="tab"
        aria-controls="contacts"
        aria-selected="true"
        (click)="setActiveTab('contacts')"
      >
        <i class="mdi mdi-account d-md-none d-block"></i>
        <span class="d-none d-md-inline">{{ 'contact.contact.tabContacts' | translate }}</span>
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        id="group-contacts-tab"
        data-bs-toggle="tab"
        data-bs-target="#group-contacts"
        type="button"
        role="tab"
        aria-controls="group-contacts"
        aria-selected="false"
        (click)="setActiveTab('group-contacts')"
      >
        <i class="mdi mdi-account-group d-md-none d-block"></i>
        <span class="d-none d-md-inline">{{ 'contact.contact.tabGroups' | translate }}</span>
      </a>
    </li>
    @if(getModuleCustomerPortfolio()) {
    <li class="nav-item">
      <a
        class="nav-link"
        id="portifolio-tab"
        data-bs-toggle="tab"
        data-bs-target="#portifolio"
        type="button"
        role="tab"
        aria-controls="portifolio"
        aria-selected="false"
        (click)="setActiveTab('portifolio')"
      >
        <i class="mdi mdi-briefcase-outline d-md-none d-block"></i>
        <span class="d-none d-md-inline">{{ 'contact.contact.tabPortfolio' | translate }}</span>
      </a>
    </li>
    }
  </ul>

  @if (showToggle) {
  <div class="position-absolute end-0 top-0">
    <a
      class="btn btn-outline-secondary fw-bold"
      [matTooltip]="
        (toggleTableCard ? 'contact.contact.showAsTable' : 'contact.contact.showAsCards') | translate
      "
      (click)="toggleTableCards()"
    >
      <i
        class="ri"
        [ngClass]="toggleTableCard ? 'ri-list-check' : 'ri-grid-fill'"
      ></i>
    </a>
  </div>
  }
</div>

<div class="tab-content" id="tabComponentsContent">
  <div
    class="tab-pane fade show active"
    id="contacts"
    role="tabpanel"
    aria-labelledby="contacts-tab"
  >
    <contact-list-component
      [toggleTableCard]="toggleTableCard"
    ></contact-list-component>
  </div>

  <div
    class="tab-pane fade"
    id="group-contacts"
    role="tabpanel"
    aria-labelledby="group-contacts-tab"
  >
    <contact-group-component
      [toggleTableCard]="toggleTableCard"
    ></contact-group-component>
  </div>

  @if(getModuleCustomerPortfolio()) {
  <div
    class="tab-pane fade mt-5"
    id="portifolio"
    role="tabpanel"
    aria-labelledby="portifolio-tab"
  >
    <div class="card">
      <table class="table table-hover table-centered mb-0">
        <thead>
          <tr>
            <th class="text-primary-emphasis">{{ 'contact.contact.colNameEmail' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (item of pagerUser.list; track $index) {
          <tr
            (click)="showContacts(item); $event.stopPropagation()"
            style="cursor: pointer"
          >
            <td>
              <div class="d-flex align-items-start">
                <div class="avatar placeholder mb-2 me-2 rounded-circle">
                  <img
                    [src]="getUserImage(item)"
                    [alt]="'contact.contact.userImageAlt' | translate"
                    class="img-fluid avatar-sm rounded-circle"
                  />
                </div>
                <div class="d-flex flex-column align-items-start mt-1">
                  <span class="fw-bold">
                    {{ item?.name ?? "-" }}
                  </span>
                  <small class="text-muted">
                    {{ item?.email ?? "-" }}
                  </small>
                </div>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  }
</div>
